import {
  buildFilters,
  fixLogoAltText,
  hideOnEmpty,
  installLogoOrganizationInterceptor,
  stripCountryInLocationStrings,
} from '../../../javascripts/utils/jobiqo';

// Install the fetch interceptor at module load time — before jobiqoJobWidget.init()
// is ever called — so the logo→company map is ready when the widget renders cards.
const logoOrganizationMap = installLogoOrganizationInterceptor();

const configEl = document.querySelector<HTMLScriptElement>('[data-jobiqo-list-config]');

if (configEl) {
  const config = JSON.parse(configEl.textContent ?? '{}');

  const initWidget = (): void => {
    const section = document.querySelector<HTMLElement>(`[data-jobiqo-widget="${config.widgetId}"]`);
    if (section && config.color) {
      section.style.setProperty('--jobiqo-card-bg-color', config.color);
    }

    const filters: Record<string, unknown> = {};

    if (config.filter.searchTerm) {
      filters.what = config.filter.searchTerm;
    }

    const { taxonomy, extraConditions } = buildFilters(config.filter);
    if (taxonomy) filters.taxonomy = taxonomy;
    if (extraConditions) filters.extraConditions = extraConditions;

    const jobiqoWidgetConfig = {
      // Falls back to location.origin when env vars are empty (reverse-proxy mode)
      backendDomain: config.backendDomain ?? window.location.origin,
      baseUrl: config.baseUrl ?? window.location.origin,
      showSearchBar: false,
      showSearchResult: true,
      slider: false,
      utmParameters: 'false', // disable default utm params
      jobAmount: config.limit,
      filters,
      styles: {
        fontFamily: '"Work Sans", Helvetica, Arial, sans-serif',
        order: ['title', 'location'],
      },
    };
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console -- Dev-only debug logging
      console.log('jobiqoWidgetConfig', jobiqoWidgetConfig);
    }
    jobiqoJobWidget!.init(jobiqoWidgetConfig);

    const widgetEl = document.querySelector<HTMLElement>('#jobiqo_job_widget');
    if (widgetEl && section) {
      hideOnEmpty(widgetEl, section);
    }
    if (widgetEl) {
      stripCountryInLocationStrings(widgetEl);
      fixLogoAltText(widgetEl, logoOrganizationMap);
    }
  };

  if (typeof jobiqoJobWidget !== 'undefined') {
    initWidget();
  } else {
    document.addEventListener('jobiqoWidgetLoaded', initWidget);
  }
}
